import React, {useState} from 'react'
import styled from 'styled-components'
import {ObjectState} from 'types'
import {useTranslation} from 'i18n'
import {AUTH_USERNAME_MAX_LENGTH, REGEX_ALLOWED_USERNAME} from 'consts'
import {Button, Input, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(335)};
  padding: ${convertUnit(20)};
  text-align: center;
`
const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(16)};
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledButton = styled(Button)`
  width: 100%;
`
const StyledInputContainer = styled.div`
  width: 100%;
  margin: ${convertUnit(20)} 0;
`
const StyledError = styled(Paragraph)`
  margin-top: ${convertUnit(4)};
  text-align: left;
`

interface GiftShopTemplateModalMFAQuestionProps {
  stateError: ObjectState<string>
  stateLoading: ObjectState<boolean>
  onVerify(answer): void
  onToggle(): void
}
export default function GiftShopTemplateModalMFAQuestion({
  stateError,
  stateLoading,
  onVerify,
  onToggle,
}: GiftShopTemplateModalMFAQuestionProps) {
  const {translate} = useTranslation()
  const [answer, setAnswer] = useState('')
  const [error, setError] = stateError
  const loading = stateLoading[0]

  return (
    <StyledModal
      visible
      onBackdropPress={() => {
        setAnswer('')
        setError('')
        onToggle()
      }}>
      <StyledTitle fontSize="l" fontWeight="bold">
        {translate('giftShop:settingAuthAppRecoveryModalTitle')}
      </StyledTitle>
      <StyledInputContainer>
        <Input
          allowedCharacters={REGEX_ALLOWED_USERNAME}
          maxLength={AUTH_USERNAME_MAX_LENGTH}
          rightIcon="delete"
          label={translate('giftShop:settingAuthAppRecoveryQuestion')}
          onChangeText={(text) => setAnswer(text)}
          placeholder={translate('giftShop:settingAuthAppRecoveryPlaceholder')}
          contentContainerStyle={{width: 'fill-available'}}
        />
        {error && (
          <StyledError fontWeight="medium" color="danger_5">
            {error}
          </StyledError>
        )}
      </StyledInputContainer>
      <StyledButtonContainer>
        <StyledButton
          label={translate('global:cancel')}
          color="primary_5"
          backgroundColor="white_3"
          onClick={() => {
            setAnswer('')
            setError('')
            onToggle()
          }}
        />
        <StyledButton
          label={translate('global:disable')}
          disabled={answer === ''}
          isLoading={loading}
          onClick={() => onVerify(answer)}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
